import React, { Component } from "react";
import { Radio, Card } from "antd";
import CasesChart from "../enterprise/repo/field-agg";
import { withRouter } from "react-router";
import PropTypes from "prop-types";

const styles = {
  cardContent: {
    width: "100%",
    padding: "8px 0 0 0",
    textAlign: "center"
  },
  verticalGutter: {
    marginTop: 16
  }
};

const PARAM_MAPPING = {
  jctvc: {
    path: "/standards/open/hevc",
    path_qs: {
      standard: "hevc",
      documents: "latest"
    },
    es_url: "/repos/jvt,jctvc,jvet/_search",
    es_query: {
      standard: "hevc",
      is_latest: "true"
    }
  },
  jvt: {
    path: "/standards/open/hevc",
    path_qs: {
      standard: "avc",
      documents: "latest"
    },
    es_url: "/repos/jvt,jctvc,jvet/_search",
    es_query: {
      standard: "avc",
      is_latest: "true"
    }
  },
  "3gpp_lte": {
    path: "/standards/open/3gpp",
    path_qs: {
      spec_standard: "4G"
    },
    es_url: "/repos/3gpp/_search",
    es_query: {
      spec_standard: "4G"
    }
  },
  "3gpp_5g": {
    path: "/standards/open/3gpp",
    path_qs: {
      spec_standard: "5G"
    },
    es_url: "/repos/3gpp/_search",
    es_query: {
      spec_standard: "5G"
    }
  },
  ieee80211: {
    path: "/standards/open/ieee",
    path_qs: {
      standard: "802.11"
    },
    es_url: "/repos/ieee802/_search",
    es_query: {
      standard: "802.11"
    }
  },
  ietf: {
    path: "/standards/open/ietf",
    path_qs: {},
    es_url: "/repos/ietf/_search",
    es_query: {}
  }
}

class StackedBarChart extends Component {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string
      })
    ),
    esUrlBase: PropTypes.string,
    field: PropTypes.string,
    flag: PropTypes.string,
    extra: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  state = {
    esKey: this.props.options[0].value
  };

  render() {
    const { options, esUrlBase, field, flag, extra } = this.props;
    const { esKey } = this.state;
    const esUrl = `${esUrlBase}${PARAM_MAPPING[esKey].es_url}`;
    const view = PARAM_MAPPING[esKey].es_query && PARAM_MAPPING[esKey].es_query.count_by === "family" ? "family" : "pub";
    const tickFormatY = label => (label.length > 15 ? `${label.slice(0, 15)}...` : label);
    return (
      <Card title={flag} extra={extra} bodyStyle={styles.cardContent} style={styles.verticalGutter}>
        <Radio.Group value={esKey} onChange={e => this.setState({ esKey: e.target.value })}>
          {options.map((opt, i) => (
            <Radio.Button value={opt.value} key={i}>
              {opt.label}
            </Radio.Button>
          ))}
        </Radio.Group>
        <div style={{ width: "100%", overflow: "auto" }}>
          <CasesChart
            view={view}
            field={field}
            size={10}
            esUrl={esUrl}
            filter={PARAM_MAPPING[esKey].es_query}
            onSelectBar={v => this.props.router.push({
              pathname: PARAM_MAPPING[esKey].path,
              query: {
                ...PARAM_MAPPING[esKey].path_qs,
                ...v
              }
            })}
            tickFormatY={tickFormatY}
            margin={{ left: 40, right: 16, top: 40, bottom: 16 }}
            exportable={false}
          />
        </div>
      </Card>
    );
  }
}

export default withRouter(StackedBarChart);
